import { jsx as o, jsxs as d } from "react/jsx-runtime";
import { b5 as m, b6 as _, b7 as $, b8 as b, aA as g, j as u, d as p, al as h } from "../../vendor-Dd6qj6gJ.js";
import { forwardRef as T } from "react";
import { BaseIcon as l } from "../BaseIcon/index.js";
import '../../assets/index61.css';const B = "_region_10065_1", x = "_toast_10065_24", A = "_success_10065_42", N = "_error_10065_50", v = "_icon_10065_58", I = "_content_10065_67", k = "_message_10065_73", y = "_actionButton_10065_81", R = "_closeButton_10065_82", n = {
  region: B,
  toast: x,
  success: A,
  error: N,
  icon: v,
  content: I,
  message: k,
  actionButton: y,
  closeButton: R
}, S = 5e3, C = 5, O = {
  error: "warning",
  success: "checkmark2"
}, r = new _();
let c = [];
function i(t) {
  c = c.filter((e) => e !== t);
}
function j() {
  if (c.length < C) return;
  const t = c[0];
  i(t), r.close(t);
}
function f(t, e, a = {}) {
  j();
  const s = r.add(
    { action: a.action, message: t, variant: e },
    {
      onClose: () => {
        i(s), a.onClose?.();
      },
      timeout: a.isIndefinite ? void 0 : S
    }
  );
  return c = [...c, s], s;
}
const L = {
  dismiss(t) {
    const e = t ?? c.at(-1);
    e !== void 0 && (i(e), r.close(e));
  },
  dismissAll() {
    for (const t of c)
      r.close(t);
    c = [];
  },
  error(t, e) {
    return f(t, "error", e);
  },
  success(t, e) {
    return f(t, "success", e);
  }
};
function w({ action: t }) {
  return t.href !== void 0 ? /* @__PURE__ */ o(
    h,
    {
      className: n.actionButton,
      "data-component": "ToastAction",
      href: t.href,
      slot: null,
      children: t.label
    }
  ) : /* @__PURE__ */ o(
    u,
    {
      className: n.actionButton,
      "data-component": "ToastAction",
      onPress: t.onPress,
      slot: null,
      children: t.label
    }
  );
}
function E({ toast: t }) {
  const { action: e, message: a, variant: s } = t.content;
  return /* @__PURE__ */ d(
    $,
    {
      className: p(n.toast, n[s]),
      "data-component": "Toast",
      "data-variant": s,
      toast: t,
      children: [
        /* @__PURE__ */ o("span", { "aria-hidden": "true", className: n.icon, children: /* @__PURE__ */ o(l, { icon: O[s], size: "sm" }) }),
        /* @__PURE__ */ o(b, { className: n.content, children: /* @__PURE__ */ o(g, { className: n.message, slot: "title", children: a }) }),
        e && /* @__PURE__ */ o(w, { action: e }),
        /* @__PURE__ */ o(
          u,
          {
            "aria-label": "Dismiss notification",
            className: n.closeButton,
            "data-component": "ToastCloseButton",
            slot: "close",
            children: /* @__PURE__ */ o(l, { icon: "close", size: "sm" })
          }
        )
      ]
    }
  );
}
const P = T(
  function(e, a) {
    return /* @__PURE__ */ o(
      m,
      {
        className: n.region,
        style: { marginBlockStart: e.offsetY },
        "data-component": "ToastRegion",
        queue: r,
        ref: a,
        children: ({ toast: s }) => /* @__PURE__ */ o(E, { toast: s })
      }
    );
  }
);
export {
  P as ToastRegion,
  L as toast
};
